import { Check } from '@sparkware/app-utils';
import {ID_VERIFICATION_STATUS} from '../../../../oauth/oauth_const';
import {TimeSpan} from "@sparkware/app-utils";
import OptionsComponentController from '../../../../../components/options/options_component_controller';
import COMBaseRegulation from "../com_base_regulation";
import { TSR_TYPE } from '../../../../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/time-spent-reminder-options';

interface AccountData {
    IdVerificationStatus: number,
    AddressVerificationStatus: number,
    RealityCheckDataIntervalInMins: number
}

export default class UKRegulation extends COMBaseRegulation {
    static CLASS = 'UKRegulation';

    private _getAccountData(): AccountData {
        return this.serviceFactory.userService().getAccountData() as AccountData;
    }

    isAnonymousPlayAllowed() : boolean {

        if(!this.serviceFactory.oAuth2Service().isAuthorized()) {
            return false;
        }

        return this._getAccountData().IdVerificationStatus === ID_VERIFICATION_STATUS.AGE_VERIFIED;
    }

    forceDemoButton(): boolean {

        return this.isAnonymousPlayAllowed() && this._getAccountData().AddressVerificationStatus !== ID_VERIFICATION_STATUS.ADDRESS_VERIFIDED;
    }

    protected realityCheckEnabled(): boolean {
        return true;
    }

    getRealityCheckInterval(): TimeSpan {
         if (this.serviceFactory.skinService().useControlCenterForReminderInterval()) {
             if (this._getAccountData() && !Check.isNullOrUndefined(this._getAccountData().RealityCheckDataIntervalInMins)) {
                 return TimeSpan.fromMinutes(this._getAccountData().RealityCheckDataIntervalInMins);
             }
         }
         return this.serviceFactory.componentFactoryService().createComponent(OptionsComponentController).getReminderInterval();
    }

    getRealityCheckIntervalExpectedByTheGame() {
        let interval = this.getRealityCheckInterval();
        return {
            timeSpan: interval,
            expectedValueByTheGame: Math.round(interval.totalSeconds)
        }
    }

    shouldHaveBetLimitsPerBrand(): boolean {
        return true;
    }

    showNetPosition(): boolean {
        return true;
    }

    sessionTimerEnabled() {
        const isMiniCip = this.serviceFactory.integrationService().isMiniCip();
        return !isMiniCip && (this.getRealityCheckInterval().totalMilliseconds > 0);
    }

    _handleRealityCheckMessage(sessionTimer) {
        this.serviceFactory.gameService().stopCurrentGameAutoplay();

        this.serviceFactory.orbitComponentRenderService().showTimeSpentReminder({
            timerType: TSR_TYPE.SESSION_TIMER,
            playingTime: this.getCurrentSessionTime()
        });
    }

}